export default __webpack_public_path__ + "static/mightyc-teaser2-desktop-02ba291d23e1941237439301af043ac9.png";